class BlockForm {
	constructor() {
		this.maps = document.querySelectorAll(".block-form .gmap");

		if (!this.maps) {
			return;
		}

		if (!this.loaded) {
			this.loaded = true;
			LoadScript.load("https://maps.googleapis.com/maps/api/js?key="+mcubeArgs.gmapApiKey, () => {
				this.buildMaps();
			});
		} else {
			this.buildMaps();
		}
	}

	buildMaps() {
		this.maps.forEach(map => {
			const lat = map.dataset.lat;
			const lng = map.dataset.lng;
			const zoom = map.dataset.zoom;
			const icon = map.dataset.icon;

			if (lat && lng) {
				this.map = new google.maps.Map(map, {
					center: {lat:  parseFloat(45.794928), lng:  parseFloat(4.766706)},
					zoom:  parseFloat(zoom),
					maxZoom: 18,
					disableDefaultUI: true,
					styles: googleMapStyle
				});

				const marker = new google.maps.Marker({
					position: {
						lat: parseFloat(lat),
						lng: parseFloat(lng)
					},
					map: this.map,
					icon: icon ? icon : false
				});
			}
		});

	}
}